import common from './common';
import fieldValidation from './fieldValidation';
import invoiceManagement from './invoiceManagement';

const zhHant = { common, invoiceManagement, fieldValidation };
export default zhHant;
